import { render, staticRenderFns } from "./temporary_display_details.vue?vue&type=template&id=9d2efe38&scoped=true&"
import script from "./temporary_display_details.vue?vue&type=script&lang=js&"
export * from "./temporary_display_details.vue?vue&type=script&lang=js&"
import style0 from "./temporary_display_details.vue?vue&type=style&index=0&id=9d2efe38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2efe38",
  null
  
)

export default component.exports